import React from "react";
import { BooleanInput } from "react-admin";
const styles = {
  flexRow: {
    display: "flex",
    flexDirection: "row",
    fontFamily: "Arial",
  },
};

const ContactOptInCheckBox = () => {
  return (
    <div style={styles.flexRow}>
      <div>
        <b>
          By checking this box you are opting in to receive SOS emergency alerts
          via SMS. Message and data rates apply. Message frequency varies. These
          alerts will be sent any time an emergency alert is broadcast from this
          system. You can respond to the SMS with HELP to learn more, Stop to
          remove your phone number from the list.
          <a href="https://sos-tech.com/privacy?hsLang=en" target="blank">
            Privacy Policy
          </a>
          {`&`}
          <a href="https://sos-tech.com/terms?hsLang=en" target="blank">
            Terms and Conditions
          </a>
          .
        </b>
      </div>
    </div>
  );
};

export default ContactOptInCheckBox;
